module.exports = require("@material-ui/core/Avatar");